export default "__VITE_ASSET__5WjlIOel__"